import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../../appConstants';
import axios from 'axios';

type ImageCmpProps = {
    url: string
}
const ImageCmp: React.FC<ImageCmpProps> = ({url}) => {
    const [imageUrl, setImageUrl] = useState(""); // State for the image URL
    const getImage = async (url : string) => {
        const token = localStorage.getItem("token");
        try {
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        let api = `${BASE_URL}utils`;
        const result = await axios.post(api, { url }, { headers });
        const { results } = result?.data?.data;
        if (results?.image !== "") {
            setImageUrl(results?.image);
            return results?.image;
        }
        } catch (error) {
        // appError(error);
        }
    };

    useEffect(() => {
        getImage(url);
    }, [url]); 

    return (
        <div className="h-[30px] w-[30px]">
            <img
            src= {imageUrl}
            className="h-[30px] w-[30px]"
            alt=""
            />
        </div>
    )
}

export default ImageCmp;
